import * as React from "react";
import { ResponsiveBar } from "@nivo/bar";
import { barColor } from "../../../libs/commission_calculator_dashboard";
export const BarChart = ({ data, keys, indexBy, colorAttribute, title }) => {
  return (
    <ResponsiveBar
      data={data}
      keys={keys}
      indexBy={indexBy}
      margin={{ top: 10, right: 20, bottom: 0, left: 20 }}
      padding={0.3}
      maxValue={100}
      layout="horizontal"
      colors={barColor(data[0][colorAttribute])}
      colorBy="index"
      borderWidth={0}
      borderColor={{ from: "color", modifiers: [["darker", "0.1"]] }}
      axisTop={{
        tickSize: 0,
        tickValues: [],
        legend: title,
        legendPosition: "start",
        legendOffset: 4,
      }}
      axisRight={null}
      axisBottom={null}
      axisLeft={null}
      enableGridY={false}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor="#ffffff"
      labelFormat={v => `${v}%`}
      animate={true}
      motionStiffness={90}
      motionDamping={15}
      defs={[
        {
          id: "lines",
          type: "patternLines",
          background: "inherit",
          color: "#eed312",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      fill={[
        {
          match: {
            id: 999999,
          },
          id: "lines",
        },
      ]}
    />
  );
};



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/dashboard/BarChart.tsx